class SiteHeader {
  el;
  buttonOpen;
  isotype;
  mqmd;

  constructor(siteHeader) {
    this.el = siteHeader;
    this.buttonOpen = this.el.querySelector(".button-side-menu");
    this.sideMenu = document.querySelector(".js-side-menu");
    this.isotype = this.el.querySelector(
      ".site-header-toolbar__logotype-isotype"
    );
    this.mqmd = window.matchMedia("(min-width: 768px)");
    this.bindListeners();
  }

  bindListeners() {
    let isLogoMoved = false;
    if (this.mqmd.matches) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 0 && !isLogoMoved) {
          this.isotype.classList.add("scrolled");
          isLogoMoved = true;
          setTimeout(() => {
            window.scrollTo(0, window.scrollY);
          }, 1000);
          this.buttonOpen.style.display = "block";
        } else if (window.scrollY === 0) {
          this.isotype.classList.remove("scrolled");
          isLogoMoved = false;
          if ((this.buttonOpen.style.display = "none")) {
            this.sideMenu.classList.remove("open");
          }
        }
      });
    }
  }
}

class SideMenu {
  body;
  el;
  buttonOpen;
  buttonClose;
  mqmd;

  constructor(sideMenu) {
    this.el = sideMenu;
    this.buttonOpen = document.querySelector(".button-side-menu");
    this.buttonClose = this.el.querySelector(".button-close");
    this.menuItems = this.el.querySelectorAll(".menu");
    this.bindListeners();
  }

  bindListeners() {
    this.buttonOpen.addEventListener("click", this.open.bind(this));
    this.buttonClose.addEventListener("click", this.close.bind(this));
    this.menuItems.forEach((item) => {
      item.addEventListener("click", this.close.bind(this));
    });
  }

  open() {
    this.el.classList.add("open");
  }

  close() {
    this.el.classList.remove("open");
  }
}

const siteHeader = document.querySelector(".js-site-header");
if (siteHeader) {
  new SiteHeader(siteHeader);
}

const sideMenu = document.querySelector(".js-side-menu");
if (sideMenu) {
  new SideMenu(sideMenu);
}
